function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21 19H3c-.551 0-1-.449-1-1V6.203l9.372 7.575a.996.996 0 001.256 0L22 6.203V18c0 .551-.449 1-1 1zm-.693-14L12 11.714 3.693 5h16.614zM21 3H3C1.346 3 0 4.346 0 6v12c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z"
});

var SvgIconMessage = function SvgIconMessage(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgIconMessage;